export const REFERRAL_PARAM_KEYS = ['referStationId', 'referUserId', 'referStationCode', 'referUserCode']

const REFER_USER_CODE_OFFSET = 100000

export function normalizeReferUserCode(value) {
  return String(value || '')
    .toUpperCase()
    .replace(/[^0-9A-F]/g, '')
}

export function getReferUserIdFromReferUserCode(value) {
  if (!value || typeof value !== 'string') {
    return null
  }

  // Kiểm tra chuỗi chỉ chứa ký tự HEX hợp lệ
  const hexRegex = /^[0-9A-Fa-f]+$/
  if (!hexRegex.test(value)) {
    return null
  }

  const referUserId = parseInt(value, 16) - REFER_USER_CODE_OFFSET

  if (isNaN(referUserId) || referUserId < 0) {
    return null
  }

  return referUserId
}

export function buildReferralPayload(params = {}) {
  const payload = {}

  const referStationId = Number(params.referStationId)

  const referUserId =
    Number(params.referUserId) ||
    getReferUserIdFromReferUserCode(params.referUserCode)

  if (Number.isFinite(referStationId) && referStationId > 0) {
    payload.referStationId = referStationId
  }

  if (Number.isFinite(referUserId) && referUserId > 0) {
    payload.referUserId = referUserId
  }

  return payload
}